import axios from "axios";
import store from "@/store/index";
import router from "@/router/index";
import { Loading } from "element-ui";

const request = axios.create({
  baseURL: systemConfig.serverUrl, //接口地址
  timeout: 20 * 1000,
});

let loading;

function startLoading() {
  loading = Loading.service({
    lock: true,
    text: "加载中...",
    background: "rgba(0, 0, 0, 0.3)",
  });
}

function endLoading() {
  // 延迟500ms，防止网速特快加载中画面一闪而过
  setTimeout(function () {
    if (loading) loading.close();
  }, 500);
}

//请求拦截
request.interceptors.request.use(
  (config) => {
    config.headers.RequestSource = "manage";
    const token = sessionStorage.getItem("access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // if(config.url != '/zxd-ywgl/data-syn/restore/log' && config.url != '/file-system/data-syn/restore'){
    //   startLoading();
    // }

    return config;
  },
  (error) => {
    // if(config.url != '/zxd-ywgl/data-syn/restore/log' && config.url != '/file-system/data-syn/restore'){
    //   endLoading();
    // }
    return Promise.reject(error);
  },
);

//响应拦截
request.interceptors.response.use(
  (response) => {
    //console.log("响应拦截");
    if (
      response.config.url != "/zxd-ywgl/data-syn/restore/log" &&
      response.config.url != "/file-system/data-syn/restore"
    ) {
      endLoading();
    }
    return response;
  },
  (error) => {
    console.log("响应拦截error", error, error.response.data);
    //请求返回401，表示token失效，跳转到登录
    switch (error.response.status) {
      case 401:
        // store.dispatch("clearAllVuex");
        // sessionStorage.clear();
        // router.push("/login");
        sessionStorage.clear();
        window.location.reload();
        this.$message.success(res.data.message);

        // 重置路由
        const { resetRouter } = require("@/router");
        resetRouter();
        // 重置 Vuex 菜单
        store.commit("permission/SET_MENU_LIST", []);
        router.push("/login");
        break;
      default:
    }
    // switch (error.response.status) {
    //     case 401:
    //         store.dispatch("clearAllVuex");
    //         sessionStorage.clear();
    //         router.push("/login");
    //         break;
    //     default:
    // }
    // if(response.config.url != '/zxd-ywgl/data-syn/restore/log' && response.config.url != '/file-system/data-syn/restore'){
    //   endLoading();
    // }
    return Promise.reject(error);
  },
);

export default request;
